import { Component, OnInit } from '@angular/core';
import {
    MatSnackBar,
    MatSnackBarHorizontalPosition,
    MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ToastComponent } from 'src/app/components/toast/toast.component';
import { FormsService } from 'src/app/services/forms.service';
import { getCookie } from 'src/app/utils/get-cookie';
import { setOnboardingAction } from './store/home.actions';
import { getOnboardingSelectors } from './store/home.selectors';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  studyId = 0;
  token = '';
  formsId = 0;
  isLoading = false;

  check$: Observable<any>;
  horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  durationInSeconds = 2;

  constructor(
    private store: Store,
    private _snackBar: MatSnackBar,
    private formsService: FormsService,
    private router: Router
  ) {}
  ngOnInit(): void {
    this.verifyStudyAndToken();
  }

  startGuia(): void {
    this.setStateOnboarding(true);
    this.getStateOnboarding();
    this.isLoading = true
    this.formsService.createForms(this.studyId).subscribe(
      (res: any) => {
        if (res.success) {
          localStorage.setItem('formsId', res.data.id);
          document.cookie = `formsId=${res.data.id}; path=/; domain=.techfinance.com.br`;
          this.router.navigate(['/presentation']);
        }
      },
      (error) => {
        this._snackBar.openFromComponent(ToastComponent, {
          horizontalPosition: this.horizontalPosition,
          verticalPosition: this.verticalPosition,
          duration: this.durationInSeconds * 1000,
          panelClass: 'red-snackbar',
          data: { title: 'Erro ao iniciar o guia. Tente novamente.' },
        });
      }
    );
  }

  setStateOnboarding(check: boolean) {
    this.store.dispatch(setOnboardingAction({ check }));
  }

  getStateOnboarding() {
    this.check$ = this.store.select(getOnboardingSelectors);
    // Assine ao Observable para obter o valor do seletor
    this.check$.subscribe((value) => {});
  }

  defaultPricingAlert() {
    let title = 'Novo Guia iniciado';
    this._snackBar.openFromComponent(ToastComponent, {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: this.durationInSeconds * 1000,
      panelClass: 'green-snackbar',
      data: { title },
    });
  }

  verifyStudyAndToken() {
    this.studyId = Number(getCookie('studyId'));
    this.formsId = Number(getCookie('formsId'));
    this.token = getCookie('token');

    if (this.formsId) {
      document.cookie =
        'formsId=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.techfinance.com.br';
      document.cookie =
        'studyId=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.techfinance.com.br';
      setTimeout(() => {
        location.href = 'https://app.techfinance.com.br';
      }, this.durationInSeconds * 1000);
      return;
    }

    if (!this.studyId || !this.token) {
      this._snackBar.openFromComponent(ToastComponent, {
        horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition,
        duration: this.durationInSeconds * 2000,
        panelClass: 'red-snackbar',
        data: {
          title:
            'Dados de sessão inválidos. Redirecionando para a techfinance...',
        },
      });
      setTimeout(() => {
        location.href = 'https://app.techfinance.com.br';
      }, this.durationInSeconds * 1000);
      return;
    }
  }
}
